package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.domain.mergeAllSplitBooks
import kotlinx.serialization.Serializable

/**
 * A tab of the Browse screen. [hasBooks]: its list is of books, each opening on its parts, between
 * the previous and the next book. Without books (the "שונות" tab) the list is of the parts
 * themselves, of one book named [items].
 */
@Serializable
enum class BrowseMode(val index: Int, val hasBooks: Boolean = true) {
    BIBLE_MODE(index = 0) {
        override fun items(): List<String> = BooksRepository.bookNamesHebrew
    },
    CHUMASH_MODE(index = 1) {
        override fun items(): List<String> = BooksRepository.chumashim
    },
    SEDARIM_MODE(index = 2) {
        override fun items(): List<String> = BooksRepository.bookNamesHebrew.mergeAllSplitBooks()
    },
    SHONOT_MODE(index = 3, hasBooks = false) {
        override fun items(): List<String> = listOf("שונות")
    };

    abstract fun items(): List<String>
}
